import { apiFetch } from "#lib/api";
import {
  IComment,
  IPost,
  IPostAttachment,
  IPostPreview,
  IPostRevision,
  IPostVideo,
} from "#entities/posts";
import { Creator } from "#api/creators";

interface IResult {
  props: {
    currentPage: "revisions";
    service: string;
    artist: Creator;
    flagged: string | null;
    revisions: [number, IPostRevision][];
  };
  post: IPost;
  comments: IComment[];
  result_previews: IPostPreview[];
  result_attachments: IPostAttachment[];
  videos: IPostVideo[];
  archives_enabled: boolean;
}

export async function fetchPostRevision(
  service: string,
  creatorId: string,
  postID: string,
  revisionId: string
) {
  const path = `/${service}/user/${creatorId}/post/${postID}/revision/${revisionId}`;

  const result = await apiFetch<IResult>(path);

  return result;
}
